import { keyframes } from 'styled-components';
var autofillKeyframes = keyframes([""]);
export default autofillKeyframes;